import React from 'react';
import { Button, Col, Form, Input, message, Modal, Row } from 'antd';
import { addMCPServerApp } from '../../MCPResearchUI/MCPServerApis';

const AppAdditionModal = ({ open, onSuccess, onClose }) => {
    const [form] = Form.useForm();
    const onAdd = async (values) => {
        await addMCPServerApp(values).then(() => {
            message.success('MCP Server App added successfully');
            form.resetFields();
            onSuccess();
         }).catch((error) => {
            console.error('Error adding MCP Server App:', error);
            message.error(error.message?? 'Failed to add MCP Server App');
        });
    };

    return (
        <Modal title='Add MCP Server App' open={open} footer={false} onCancel={onClose} width={'80%'}>
            <Form name='add_mcp_app' form={form} onFinish={onAdd}>
                <Row gutter={8}>
                    <Col span={6}>
                        <Form.Item name={'appName'} rules={[{ required: true, message: 'App Name is required' }]}>
                            <Input placeholder='App Name' />
                        </Form.Item>
                    </Col>
                    <Col span={16} className='items-baseline'>
                        <Form.Item
                            name={'url'}
                            rules={[
                                { required: true, message: 'URL is required' },
                                {
                                    validator: (_, value) => {
                                        const isValid = /^(http|https):\/\//i.test(value);
                                        if (!isValid) {
                                            return Promise.reject(new Error('Invalid URL. It should start with http or https.'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder='URL' />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item>
                            <Button type='primary' htmlType='submit'>
                                Add
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default AppAdditionModal;
